import React from 'react';
import { Popup } from 'antd-mobile';

export default function AiAnalysisTipPopup({ visible, onClose }) {
  return (
    <Popup
      visible={visible}
      onMaskClick={onClose}
      bodyStyle={{
        borderRadius: '16px 16px 0 0',
      }}
    >
      <div style={{ padding: '20px 20px calc(20px + env(safe-area-inset-bottom))' }}>
        {/* 标题栏 */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', marginBottom: 16 }}>
          <span style={{ fontSize: 17, fontWeight: 'bold', color: '#282828' }}>AI评论分析说明</span>
          <span
            onClick={onClose}
            style={{ position: 'absolute', right: 0, fontSize: 18, color: '#999', lineHeight: 1, cursor: 'pointer' }}
          >✕</span>
        </div>

        {/* 说明文字 */}
        <div style={{ fontSize: 14, color: '#666', textAlign: 'center', marginBottom: 24, lineHeight: 1.6 }}>
          内容基于该游戏的所有评论由AI生成，仅供参考！
        </div>

        {/* 按钮 */}
        <div
          onClick={onClose}
          style={{
            background: 'var(--MainColor)',
            borderRadius: 24,
            height: 48,
            width: '60%',
            margin: '0 auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 16,
            fontWeight: 'bold',
            color: '#fff',
            cursor: 'pointer',
          }}
        >我知道了</div>
      </div>
    </Popup>
  );
}
